import React from 'react';

import { Button } from '@components/Button';
import { Dialog } from '@components/Dialog';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { formStrings } from '@utils/forms';
import { createStrings } from '@utils/local';

const strings = createStrings({
  ja: {
    changeSalesperson: '担当者があなたに変更されますが、進めてよろしいでしょうか。',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  managementButton: {
    alignSelf: 'center',
    width: 160,
    margin: '0.5rem 0',
  },
  cancelButton: {
    alignSelf: 'center',
    width: 160,
    margin: '0.5rem 0',
    backgroundColor: theme.palette.grey['500'],
    color: theme.palette.primary.contrastText,
  },
  dialogText: {
    ...common.middleText,
    ...common.fontWeight400,
    ...common.textGray800,
    textAlign: 'center',
    marginTop: 20,
    marginBottom: 60,
  },
}));

export const ChangeAssigneeDialog: React.FC<ChangeAssigneeDialogProps> = (props) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const { open, onCancel, onYes } = props;

  return (
    <Dialog open={open}>
      <div className={classes.dialogText}>{strings.changeSalesperson}</div>
      <Button
        color="custom"
        shape="round"
        size="small"
        className={classes.cancelButton}
        text={formStrings.cancel}
        onClick={onCancel}
      />
      <Button
        color="primary"
        shape="round"
        size="small"
        className={classes.managementButton}
        text={formStrings.yes}
        onClick={onYes}
      />
    </Dialog>
  );
};

export interface ChangeAssigneeDialogProps {
  open: boolean;
  onCancel: () => any;
  onYes: () => any;
}
